// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-hero[data-v-f93595bc]{width:100%;display:grid;grid-template-columns:repeat(1,minmax(0,1fr));grid-template-rows:repeat(1,minmax(0,1fr));overflow:hidden;align-items:center;text-align:center;height:60vh}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
